/* eslint-disable prefer-template */
import React, { useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { v4 as uuid } from 'uuid';
import QCXFinalBondManager from '../final-gerenciador-relacionamento/QCXFinalBondManager';
import QCXFinalNumericDecimalField from '../final-numeric-decimal-field/QCXFinalNumericDecimalField';
import QCXSelectMoedaAutocomplete from '../final-select-moeda-field/QCXSelectMoedaAutocomplete';
import { formatDate, isStrictEquals } from '../../utils/general/general-utils';
import QCXSelectComponenteFreteAutocomplete from './QCXSelectComponenteFreteAutocomplete';
import QCXSelectComponenteFreteTipoRecolhimentoAutocomplete from './QCXSelectComponenteFreteTipoRecolhimentoAutocomplete';

export default function QCXComponentesFreteFormGroup({ isConsult, listRootName }) {
  const getTaxaFormattedString = (row) => {
    if (!row?.moedaTaxa || !row?.moedaTaxaData) return 'Definida após calcular a DUIMP';

    return 'BRL ' + row?.moedaTaxa + ' em ' + formatDate(row?.moedaTaxaData);
  };

  const listProps = {
    name: listRootName,
    columns: [
      {
        field: 'componenteFrete',
        headerName: 'Componente do Frete',
        flex: 180,
        valueGetter: ({ row }) => row?.componenteFrete?.description,
      },
      {
        field: 'tipoRecolhimento',
        headerName: 'Recolhimento',
        flex: 140,
        valueGetter: ({ row }) => row?.tipoRecolhimento,
      },
      {
        field: 'moeda',
        headerName: 'Moeda',
        flex: 180,
        valueGetter: ({ row }) => row?.moeda?.code + ' - ' + row?.moeda?.description,
      },
      {
        field: 'valor',
        headerName: 'Valor',
        flex: 160,
        valueGetter: ({ row }) => row?.valor,
      },
      {
        field: 'valorReal',
        headerName: 'Valor em reais',
        flex: 180,
        valueGetter: ({ row }) => row?.valorReal,
      },
      {
        field: 'taxa',
        headerName: 'Taxa moeda',
        flex: 180,
        valueGetter: ({ row }) => getTaxaFormattedString(row),
      },
    ],
  };

  const formProps = {
    rootName: 'ignorableFields.componentesFreteBond',
    fields: [
      {
        name: 'componenteFrete',
        label: 'Componente do Frete',
        required: true,
      },
      {
        name: 'moeda',
        label: 'Moeda',
        required: true,
      },
      {
        name: 'valor',
        label: 'Valor',
        required: true,
      },
      {
        name: 'tipoRecolhimento',
        label: 'Recolhimento',
        required: true,
      },
    ],
  };

  const handleAdd = useCallback((currentVinculo, currentVinculos, handleSuccessAddVinculo) => {
    const updatedVinculos = [...currentVinculos, { ...currentVinculo, id: uuid() }];

    handleSuccessAddVinculo(updatedVinculos);
  }, []);

  const handleUpdate = useCallback((currentVinculo, currentVinculos, handleSuccessUpdateVinculo) => {
    const updatedVinculos =
      currentVinculos?.map((existingVinculo) =>
        isStrictEquals(existingVinculo?.id, currentVinculo?.id) ? currentVinculo : existingVinculo
      ) || currentVinculos;

    handleSuccessUpdateVinculo(updatedVinculos);
  }, []);

  const handleAlreadyExists = useCallback(
    (currentVinculo, currentVinculosList) =>
      currentVinculosList.some((vinculo) => isStrictEquals(vinculo?.id, currentVinculo?.id)),
    []
  );

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <QCXFinalBondManager
          isParentConsult={isConsult}
          listProps={listProps}
          formProps={formProps}
          controlButtonsGridProps={{
            add: { xs: 12, sm: 2, md: 2 },
            update: { xs: 6, sm: 1, md: 1 },
            clear: { xs: 6, sm: 1, md: 1 },
          }}
          handleAdd={handleAdd}
          handleUpdate={handleUpdate}
          handleAlreadyExists={handleAlreadyExists}
        >
          <>
            <Grid item sm={3}>
              <QCXSelectComponenteFreteAutocomplete
                id="componente-frete"
                key="componente-frete"
                name="ignorableFields.componentesFreteBond.componenteFrete"
                label="Componente do Frete"
                getOptionValue={(item) => item}
                disabled={isConsult}
              />
            </Grid>
            <Grid item sm={3}>
              <QCXSelectMoedaAutocomplete
                id="componentes-frete-moeda"
                name="ignorableFields.componentesFreteBond.moeda"
                label="Moeda"
                getOptionValue={(item) => item}
                disabled={isConsult}
              />
            </Grid>
            <Grid item sm={2}>
              <QCXFinalNumericDecimalField
                id="componentes-frete-valor"
                key="componentes-frete-valor"
                name="ignorableFields.componentesFreteBond.valor"
                label="Valor"
                disabled={isConsult}
              />
            </Grid>
            <Grid item sm={2}>
              <QCXSelectComponenteFreteTipoRecolhimentoAutocomplete
                id="componentes-frete-recolhimento"
                key="componentes-frete-recolhimento"
                name="ignorableFields.componentesFreteBond.tipoRecolhimento"
                label="Recolhimento"
                disabled={isConsult}
              />
            </Grid>
          </>
        </QCXFinalBondManager>
      </Grid>
    </>
  );
}
